'use client';

import { useLocale, useTranslations } from 'next-intl';

import { Link, routing, usePathname } from '@/i18n/routing';

import styles from './LocaleSwitcher.module.scss';

export default function LocaleSwitcher() {
	const t = useTranslations('LocaleSwitcher');
	const pathname = usePathname();
	const locale = useLocale();

	return (
		<>
			{routing.locales.map((cur) => (
				locale !== cur && <Link className={styles.localeSwitcher} href={pathname} key={cur} locale={cur}>{t(cur, { locale: cur })}</Link>
			))}
		</>
	);
}
